import addNamespaces from '../../translations/add-namespaces';
import en from '../../translations/entities/en.json';
import nl from '../../translations/entities/nl.json';
import { useManagementSidebar } from './Management.sidebar';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

addNamespaces('entities', { en, nl });

export const ManagementLayout = () => {
  const { t } = useTranslation();
  useManagementSidebar();

  return (
    <>
      <Helmet title={t('main:navigation.management')} />
      <Outlet />
    </>
  );
};
